"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeNative = void 0;
const executeNative = async (deeplink, options) => {
    if (window.MobileWebKit) {
        await window.MobileWebKit.navigation
            .push(deeplink, options)
            .catch((error) => {
            throw new Error(error);
        });
    }
};
exports.executeNative = executeNative;
